export function stringIncludes(string: string, includesString: string) {
  string = prepareStringForComparison(string);
  includesString = prepareStringForComparison(includesString);
  return string.indexOf(includesString) !== -1;
}

function prepareStringForComparison(string: string) {
  return string.toLowerCase().replace(/\s/g, '');
}
